import React from 'react';
import DSTruncatedTooltipText from '@elliemae/ds-truncated-tooltip-text';
import { accordionTitleWrapper, accordionH2Title, accordionSecondaryTitle } from './blocks.js';
import '@elliemae/ds-classnames';

var DSAccordionHeader = function DSAccordionHeader(_ref) {
  var title = _ref.title,
      secondaryTitle = _ref.secondaryTitle,
      idx = _ref.idx;
  var hasSecondaryTitle = Boolean(secondaryTitle);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(accordionTitleWrapper, " ").concat(hasSecondaryTitle ? 'with-secondary-title' : '')
  }, /*#__PURE__*/React.createElement("h2", {
    id: "accordion_".concat(idx, "id")
  }, /*#__PURE__*/React.createElement(DSTruncatedTooltipText, {
    className: accordionH2Title,
    value: title
  })), hasSecondaryTitle && /*#__PURE__*/React.createElement(DSTruncatedTooltipText, {
    className: accordionSecondaryTitle,
    containerComponent: /*#__PURE__*/React.createElement("div", null),
    value: secondaryTitle
  }));
};

export default DSAccordionHeader;
//# sourceMappingURL=DSAccordionHeaderTitle.js.map
